const MATERIALS = [
  { slug: "wrap-film", title: "Wrap film", text: "Silage and bale wrap, kept separate from other grades.", image: "tonne-bag-wrap-film" },
  { slug: "fertiliser-bags", title: "Fertiliser bags", text: "Clean, empty bags stored as their own material stream.", image: "tonne-bag-fertiliser" },
  { slug: "packaging-film", title: "Packaging film", text: "Clean LDPE, pallet wrap and shrink film, assessed before collection.", image: "tonne-bag-packaging-film" },
];

export const SeparatedMaterials = () => (
  <div data-testid="separated-materials-gallery" className="mb-12">
    <p className="max-w-3xl mb-8 text-[#4A4A4A] leading-relaxed">Keep each material stream in its own extra-large tonne bag where appropriate. If you are unsure, keep it separate and send us a photograph before booking. EPS must always be kept separate from rigid plastics.</p>
    <div className="grid sm:grid-cols-3 gap-8">
      {MATERIALS.map((material) => (
        <figure key={material.slug} data-testid={`separated-material-${material.slug}`} className="min-w-0">
          <img data-testid={`separated-material-image-${material.slug}`} src={`/images/${material.image}.webp`} alt={`${material.title} stored separately in an extra-large tonne bag`} width="200" height="185" loading="lazy" className="w-full max-w-[260px] aspect-[200/185] object-contain" />
          <figcaption className="mt-5 text-[#024120]">
            <h3 className="font-display font-bold text-base md:text-lg">{material.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-[#4A4A4A]">{material.text}</p>
          </figcaption>
        </figure>
      ))}
    </div>
  </div>
);